export default __webpack_public_path__ + "static/media/footer.979f2136.svg";